import { MemberInvitationStatus } from '@tribeplatform/gql-client/types'
import {
  useMemberInvitations,
  useNetwork,
} from '@tribeplatform/react-sdk/hooks'

export interface UseMemberInvitationCapacity {
  isInitialLoading: boolean
  memberCapacity: number
  memberCapacityDeclared: number
  totalInvitationsCount: number
  invitationsLimit: number
}

const INVITATION_LIMIT_MULTIPLIER = 3

export const useMemberInvitationCapacity = (): UseMemberInvitationCapacity => {
  const { data: network, isInitialLoading } = useNetwork({
    fields: {
      limits: 'all',
      usages: 'all',
    },
  })
  const { data } = useMemberInvitations({
    variables: { limit: 0, status: MemberInvitationStatus.Pending },
  })

  const memberCapacity =
    network?.limits?.usageLimits?.membersCapacity ?? Infinity

  return {
    isInitialLoading,
    memberCapacity,
    memberCapacityDeclared: network?.usages?.usages?.membersCapacity ?? 0,
    totalInvitationsCount: data?.pages?.[0].totalCount ?? 0,
    invitationsLimit: memberCapacity * INVITATION_LIMIT_MULTIPLIER,
  }
}
